var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackward3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 19,
    height: 19,
    transform: "rotate(-180 36 20)",
    stroke: "black",
    strokeWidth: 1.60714
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 18L2 10.5781M2 10.5781L9.38889 3.15625M2 10.5781L18.0313 10.5781",
    stroke: "black",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M24.7861 9.03906H26.1396C26.7842 9.03906 27.2617 8.87793 27.5723 8.55566C27.8828 8.2334 28.0381 7.80566 28.0381 7.27246C28.0381 6.75684 27.8828 6.35547 27.5723 6.06836C27.2676 5.78125 26.8457 5.6377 26.3066 5.6377C25.8203 5.6377 25.4131 5.77246 25.085 6.04199C24.7568 6.30567 24.5928 6.65137 24.5928 7.0791H22.0527C22.0527 6.41113 22.2314 5.81348 22.5889 5.28613C22.9521 4.75293 23.4561 4.33692 24.1006 4.03809C24.751 3.73926 25.4658 3.58985 26.2451 3.58985C27.5986 3.58985 28.6592 3.91504 29.4268 4.56543C30.1943 5.20996 30.5781 6.10059 30.5781 7.23731C30.5781 7.82324 30.3994 8.36231 30.042 8.85449C29.6846 9.34668 29.2158 9.72461 28.6357 9.98828C29.3564 10.2461 29.8926 10.6328 30.2441 11.1484C30.6016 11.6641 30.7803 12.2734 30.7803 12.9766C30.7803 14.1133 30.3643 15.0244 29.5322 15.71C28.7061 16.3955 27.6104 16.7383 26.2451 16.7383C24.9678 16.7383 23.9219 16.4014 23.1074 15.7275C22.2988 15.0537 21.8945 14.1631 21.8945 13.0557H24.4346C24.4346 13.5361 24.6133 13.9287 24.9707 14.2334C25.334 14.5381 25.7793 14.6904 26.3066 14.6904C26.9102 14.6904 27.3818 14.5322 27.7217 14.2158C28.0674 13.8936 28.2402 13.4688 28.2402 12.9414C28.2402 11.6641 27.5371 11.0254 26.1309 11.0254H24.7861V9.03906Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackward3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Backward3.9d7ae0bb638a812ab364012d2d4be3ee.svg";